import styled from 'styled-components';

const SubscribeStyle = styled.section`
	&.subscribeCont {
		--autoSelectBg: var(--color2);
		--autoSelectColor: var(--color1);

		position: relative;
		z-index: 0;
		background-color: var(--color2);

		.subscribeTop {
			padding: 0.1px;
			position: sticky;
			display: block;
			top: 100%;
			height: 0;
		}

		.loading {
			animation: loadingAnim calc(var(--trTime) * 3) ease-in-out infinite;
			pointer-events: none;
		}

		.subscribeWrap {
			position: relative;
			padding: var(--sectionToSection) 0;

			.formWrap {
				width: 100%;

				.successMessage {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					color: var(--color1);
					background-color: var(--color2);
					z-index: 14;
					text-align: center;
				}

				.formCont {
					position: relative;
				}

				.title {
					margin-bottom: var(--sp4x);
					color: var(--color1);
				}

				.btn-actions {
					width: auto;
				}

				.inputWrapClass {
					position: relative;

					.inputClass {
						overflow: hidden;

						input {
							padding: var(--sp4x) 0;
							width: 100%;
							height: 100%;
							background-color: transparent;
							border: unset;
							font-size: var(--pM);
							font-family: var(--fontFamily2);
							font-weight: var(--ffLight);
							color: var(--color1);

							&::placeholder {
								color: var(--color1);
								font-size: var(--pM);
							}

							&:focus {
								outline: 0;
							}
						}

						svg {
							height: 100%;
							stroke: var(--color1);
						}
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.subscribeWrap {
				.formWrap {
					max-width: 65%;
					margin: auto;

					.title {
						margin-bottom: var(--sp5x);
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			.subscribeWrap {
				--LogoSize: var(--sp25x);
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			.subscribeWrap {
				--LogoSize: var(--sp28x);
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			.subscribeWrap {
				.formWrap {
					.title {
						margin-bottom: var(--s8x);
					}
				}
			}
		}
	}

	@keyframes loadingAnim {
		0%,
		100% {
			opacity: 0.8;
		}

		50% {
			opacity: 0.5;
		}
	}
`;

export default SubscribeStyle;
